// extracted by mini-css-extract-plugin
export default {"customHeader":"styles_customHeader__ORaiI","customBody":"styles_customBody__Hd444"};